import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { showConfirmModal } from 'actions/global';
import DataTable from 'components/shared/DataTable';
import { deleteWarrantyPeriod } from 'services/warranty-period.service';

const WarrantyPeriodTable = (props) => {
  const { onRefresh } = props;
  const dispatch = useDispatch();
  const columns = useMemo(() => [
    {
      header: 'STT',
      classNameHeader: 'bw_text_center',
      classNameBody: 'bw_text_center',
      formatter: (_, index) => index + 1,
    },
    { header: 'Số tháng', accessor: 'period', classNameBody: 'bw_text_center' },
    { header: 'Thời hạn bảo hành', accessor: 'description' },
    { header: 'Ngày tạo', accessor: 'created_date' },
    { header: 'Người tạo', accessor: 'created_user' },
    {
      header: 'Trạng thái',
      accessor: 'is_active',
      formatter: (item) => item.is_active
        ? <span className='bw_label_outline bw_label_outline_success text-center'>Kích hoạt</span>
        : <span className='bw_label_outline bw_label_outline_danger text-center'>Ẩn</span>,
    },
  ], []);

  const actions = useMemo(() => [
    {
      globalAction: true,
      icon: 'fi fi-rr-plus',
      type: 'success',
      content: 'Thêm mới',
      permission: 'MD_WARRANTYPERIOD_ADD',
      onClick: () => window._$g.rdr('/warranty-period/add'),
    },
    {
      icon: 'fi fi-rr-edit',
      color: 'blue',
      permission: 'MD_WARRANTYPERIOD_EDIT',
      onClick: (item) => window._$g.rdr(`/warranty-period/edit/${item.warranty_period_id}`),
    },
    {
      icon: 'fi fi-rr-eye',
      color: 'green',
      permission: 'MD_WARRANTYPERIOD_VIEW',
      onClick: (item) => window._$g.rdr(`/warranty-period/detail/${item.warranty_period_id}`),
    },
    {
      icon: 'fi fi-rr-trash',
      color: 'red',
      permission: 'MD_WARRANTYPERIOD_DEL',
      onClick: (item) => dispatch(showConfirmModal(
        ['Bạn có thực sự muốn xóa?', 'Không thể xóa thời hạn đang được hàng hóa sử dụng.'],
        async () => {
          await deleteWarrantyPeriod(item.warranty_period_id);
          onRefresh();
        },
      )),
    },
  ], [dispatch, onRefresh]);

  return <DataTable {...props} columns={columns} actions={actions} />;
};

export default WarrantyPeriodTable;
